import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import messages from './messages'
import Firebase from "./firebase"
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueAnalytics from 'vue-analytics'
import Ads from 'vue-google-adsense'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'ja',
  messages
});
 
Vue.use(require('vue-script2'))
 
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.use(VueAnalytics, {
  id: 'UA-149437419-1',
  router
})

Vue.use(Buefy)

Firebase.init();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  i18n
}).$mount('#app')
